import styled from "styled-components"
import { formatAmount } from "../../utils/date"

const Item = styled.div`
  padding: 0.15rem 0;
`

type DealerListItemProps = {
  dealerName: string
  claimsMade: number
  rank: number
}

const DealerListItem = (props: DealerListItemProps) => {
  return (
    <Item>
      <div className="px-0">
        <div className="row">
          <div className="col">{props.dealerName}</div>
          <div className="col text-end fw-bold">
            {formatAmount(props.claimsMade)}
          </div>
        </div>
      </div>
    </Item>
  )
}

export default DealerListItem
